import { Check, Copy as CopyIcon } from 'lucide-react'

import { Button } from './Button.js'
import { useCopy } from './core/clipboard.js'

/** Icon-only clipboard action for copying a value. */
export function Copy(props: Copy.Props) {
  const { onCopy, title, value, ...rest } = props
  const { copy, notifying } = useCopy()
  const label = title ?? `Copy ${value}`

  return (
    <Button.Icon
      aria-label={label}
      onClick={async () => {
        if (await copy(value)) onCopy?.()
      }}
      title={label}
      {...rest}
    >
      {notifying ? <Check /> : <CopyIcon />}
    </Button.Icon>
  )
}

export namespace Copy {
  /** Props for {@link Copy}. */
  export type Props = Omit<Button.Icon.Props, 'children' | 'onClick' | 'title' | 'aria-label'> & {
    /** Called after the value is copied (e.g. to show a toast). */
    onCopy?: (() => void) | undefined
    /** Tooltip + accessible label. @default `Copy ${value}` */
    title?: string | undefined
    /** Value written to the clipboard. */
    value: string
  }
}
